import { modalController } from '@ionic/vue';

let pendingScan: Promise<string | undefined> | undefined;

/** Opens the barcode scanner and resolves with the scanned value, or `undefined` if the user closes it. */
export function startScan(): Promise<string | undefined> {
  // Repeated taps share the scanner that is already open, since the native camera can only be used once.
  pendingScan ??= openScanner().finally(() => {
    pendingScan = undefined;
  });

  return pendingScan;
}

async function openScanner() {
  // Imported lazily: utils are auto-imported everywhere, so a static import of the component would create an import cycle.
  const { default: BarcodeScannerModal } = await import('~/components/BarcodeScannerModal.vue');
  const modal = await modalController.create({
    component: BarcodeScannerModal,
    cssClass: 'barcode-scanner-modal',
    // Dismisses this modal only, never whichever modal happens to be on top.
    componentProps: { dismiss: (value?: string) => modal.dismiss(value) }
  });

  await modal.present();
  const { data } = await modal.onDidDismiss<string>();

  return data;
}
